"use client";

import { Icon } from "@/components/ui/icon";
import { Select } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export interface FilterSelectInputOption<T extends string = string> {
  value: T;
  label: string;
}

export function FilterSelectInput<T extends string = string>({
  options,
  value,
  onChange,
  placeholder = "Select",
  "aria-label": ariaLabel,
}: {
  options: FilterSelectInputOption<T>[];
  value: T | undefined;
  onChange: (value: T) => void;
  placeholder?: string;
  "aria-label"?: string;
}) {
  const current = options.find((o) => o.value === value);
  const displayLabel = current?.label ?? placeholder;
  const hasValue = current != null;

  return (
    <Select>
      <Select.Trigger variant="filter" aria-label={ariaLabel}>
        <span
          className={cn(
            "flex-1 w-full text-sm truncate text-left",
            hasValue ? "text-heading" : "text-contrast/50",
          )}
        >
          {displayLabel}
        </span>
        <Select.Icon/>
      </Select.Trigger>
      <Select.Content collisionPadding={{ top: 8, bottom: 112 }}>
        <Select.List className="max-h-[min(20rem,var(--radix-popper-available-height))]">
          {options.map((opt) => {
            const isSelected = opt.value === value;

            return (
              <Select.Item
                key={opt.value}
                
                selected={isSelected}
                onSelect={() => onChange(opt.value)}
              >
                <span
                  className={cn(
                    "flex-1 text-sm text-left",
                    isSelected ? "text-ai" : "text-foreground/75",
                  )}
                >
                  {opt.label}
                </span>
                {isSelected && <Select.ItemCheck />}
              </Select.Item>
            );
          })}
        </Select.List>
      </Select.Content>
    </Select>
  );
}
